window.mugo||={};const breakpoints={xxs:321,xs:450,sm:768,md:900,lg:1200,xlg:1441,xxlg:1675,xxxlg:1920},cssClasses={active:"is-active",added:"is-added",collapsed:"is-collapsed",disabled:"is-disabled",hidden:"is-hidden",visible:"is-visible",lazyload:"lazyload",lazyloaded:"lazyloaded",loading:"is-loading",removing:"is-removing",sale:"is-sale",sticky:"is-sticky",tabbable:"is-tabbable",utils:{lockOverflow:"util-lock-overflow"}};Object.assign(window.mugo,{breakpoints,cssClasses});
document.addEventListener("click", (e) => {
    var timer;
    var class_list = e.target.classList;
    var next_text = e.target.dataset.nextText;
    if(class_list[0] == "action" && next_text == "Next"){
        timer = setInterval(()=> {
            var success_state = document.querySelectorAll(".shopify-section .globo-form-app .message.success")[1].style.display;
            if(success_state == "block") {
                clearInterval(timer);
                document.querySelector("section[data-section-type='text']").style.display = 'none';
                document.querySelector(".shopify-section .globo-form-id-80695 .globo-form-app").style.maxWidth='700px';
                document.querySelectorAll(".shopify-section .globo-form-app .message.success .dismiss")[1].style.display='none';
                document.querySelectorAll(".shopify-section .globo-form-app .message.success")[1].style.background='transparent';
            }
        }, 100);
    }
})